import { render } from "./EnterpriseLayout.vue?vue&type=template&id=5145e7f4"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__